import { Popover } from '@mantine/core';

import classes from './Popover.module.css';

const PopoverDefaults = Popover.extend({
  defaultProps: { shadow: 'lg' },
  classNames: {
    dropdown: classes.dropdown,
    arrow: classes.arrow,
  },
});

export { Popover, PopoverDefaults };
